export default "__VITE_ASSET__DEynCRhO__"